import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { PRODUCTS_AVAILABILITY_PATH } from '../../core/constants';

export const createProductAvailabilityAction = createAsyncThunk(
    'reservation/createProductAvailabilityAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(PRODUCTS_AVAILABILITY_PATH, data);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createProductAvailabilitySlice = createSlice({
    name: 'createProductAvailabilitySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createProductAvailabilityAction.pending, () => STATE__API__STARTED);
        builder.addCase(createProductAvailabilityAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createProductAvailabilityAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createProductAvailabilityState = (state) => state.reservation.createProductAvailability;
export default createProductAvailabilitySlice.reducer;
